import React from 'react';
import Typography from '@mui/material/Typography';
import { PropTypes } from 'prop-types';

// Parametros props
//id: Id del componente
//variant: estilo del componente h1, h2, h3, h4, h5, h6, subtitle1, subtitle2, body1, body2, button, caption, overline
//label: etiqueta

Label.propTypes = {
  id: PropTypes.string,
  variant: PropTypes.string,
  label: PropTypes.string,
};

Label.defaultProps = {  
  id: 'Custom',
  variant:"subtitle1",
  label:"Default",
  color: "#98999b",
  style:{}
}  

function Label(props) {
    return (<>
                <Typography variant={props.variant}  color={props.color}  gutterBottom style={props.style}>{props.label}</Typography>
            </>)
  }

export default React.memo(Label);